module.exports = __webpack_public_path__ + "static/media/familia2.17c5bab5.jpg";